module.exports = {
	"articleTitle1": "Trailer Review: 3-D 'Pacific Rim' looks to freshen monster movie genre",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Pacific Rim",
	"articleLink1": "http://www.michigandaily.com/arts/1mini-reviewtrailer-pacific-rim31",
	"articleLink2": "https://www.michigandaily.com/content/kanas-offers-unique-french-asian-taste",
	"articleSnippet1": "Jan 31, 2013 ... Rather than glorifying an all-star cast, “Pacific Rim” builds up the actual story of \nan attack from deep beneath the sea and showcases its visual ...",
	"articleSnippet2": "Dec 6, 2001 ... This culinary style, termed Pacific Rim, is defined by owner/manager YB as \"the \nbest of Thai, Vietnamese, Chinese and Korean.\" Because of ...",
	"foodRecommendations": [],
	"articleTitle2": "Kana''s offers unique French-Asian taste",
	"address": "114 W Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279795,
		"lng": -83.749387
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/pacificrim.json
// module id = 940
// module chunks = 0